import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import API from "../../services/api";

function UserDetails() {
    const { id } = useParams();

    const [user, setUser] = useState(null);
    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [previewImage, setPreviewImage] =
        useState(null);

    useEffect(() => {
        loadUser();
    }, []);

    const loadUser = async () => {
        try {
            const token =
                localStorage.getItem("adminToken");

            const res = await API.get(
                `/admin/users/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setUser(res.data.user);
            setOffers(res.data.offers || []);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-[400px]">
                <div className="text-xl">
                    Loading...
                </div>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="flex items-center justify-center h-[400px]">
                <div className="text-xl text-red-500">
                    User Not Found
                </div>
            </div>
        );
    }

    return (
        <div>

            {/* Header */}

            <div
                className="
        bg-[#111]
        border
        border-yellow-500/20
        rounded-3xl
        p-8
        mb-8
        "
            >
                <div className="flex flex-col md:flex-row items-center gap-6">

                    <div
                        className="
    w-24
    h-24
    rounded-full
    overflow-hidden
    border-4
    border-yellow-500
    bg-[#222]
    flex
    items-center
    justify-center
  "
                    >
                        {user.profile_image ? (
                            <img
                                src={`${process.env.REACT_APP_API_URL}/uploads/${user.profile_image}`}
                                alt={user.name}
                                onClick={() =>
                                    setPreviewImage(
                                        `${process.env.REACT_APP_API_URL}/uploads/${user.profile_image}`
                                    )
                                }
                                className="
  w-full
  h-full
  object-cover
  cursor-pointer
  hover:scale-105
  transition
  "
                            />
                        ) : (
                            <span
                                className="
        text-4xl
        font-bold
        text-yellow-500
      "
                            >
                                {user.name
                                    ? user.name.charAt(0).toUpperCase()
                                    : "U"}
                            </span>
                        )}
                    </div>

                    <div className="flex-1">
                        <h1 className="text-4xl font-bold">
                            {user.name || "Unknown User"}
                        </h1>

                        <p className="text-gray-400 mt-2">
                            {user.phone}
                        </p>

                        <p className="text-gray-500 mt-1">
                            User ID: #{user.id}
                        </p>
                    </div>

                    <div>
                        <span
                            className={`
              px-5
              py-2
              rounded-full
              text-sm
              font-semibold
              ${user.status === "active"
                                    ? "bg-green-500/20 text-green-400"
                                    : "bg-red-500/20 text-red-400"
                                }
              `}
                        >
                            {user.status}
                        </span>
                    </div>

                </div>
            </div>

            {/* Stats */}

            <div
                className="
        grid
        grid-cols-1
        md:grid-cols-3
        gap-6
        mb-8
        "
            >
                <div
                    className="
          bg-[#111]
          rounded-2xl
          p-6
          "
                >
                    <p className="text-gray-400">
                        Joined Offers
                    </p>

                    <h2
                        className="
            text-4xl
            font-bold
            text-yellow-500
            mt-2
            "
                    >
                        {offers.length}
                    </h2>
                </div>

                <div
                    className="
          bg-[#111]
          rounded-2xl
          p-6
          "
                >
                    <p className="text-gray-400">
                        Status
                    </p>

                    <h2
                        className="
            text-2xl
            font-bold
            mt-3
            "
                    >
                        {user.status}
                    </h2>
                </div>

                <div
                    className="
          bg-[#111]
          rounded-2xl
          p-6
          "
                >
                    <p className="text-gray-400">
                        Registration Date
                    </p>

                    <h2
                        className="
            text-lg
            font-bold
            mt-3
            "
                    >
                        {user.created_at
                            ? new Date(
                                user.created_at
                            ).toLocaleDateString()
                            : "N/A"}
                    </h2>
                </div>
            </div>

            {/* User Information */}

            <div
                className="
    bg-[#111]
    rounded-3xl
    p-6
    mb-8
  "
            >
                <h2
                    className="
      text-2xl
      font-bold
      mb-6
    "
                >
                    User Information
                </h2>

                <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-6">

                    <div>
                        <p className="text-gray-500">
                            Wallet
                        </p>
                        <p className="mt-1">
                            {user.wallet || "N/A"}
                        </p>
                    </div>

                    <div>
                        <p className="text-gray-500">
                            Wallet Address
                        </p>
                        <p className="mt-1">
                            {user.wallet_address || "N/A"}
                        </p>
                    </div>

                    <div>
                        <p className="text-gray-500">
                            Last Seen
                        </p>
                        <p className="mt-1">
                            {user.last_seen
                                ? new Date(
                                    user.last_seen
                                ).toLocaleString()
                                : "Never"}
                        </p>
                    </div>

                </div>

            </div>

            {/* Joined Offers */}

            <div
                className="
        bg-[#111]
        rounded-3xl
        p-6
        "
            >
                <h2
                    className="
          text-2xl
          font-bold
          mb-6
          "
                >
                    Joined Offers
                </h2>

                {offers.length === 0 ? (
                    <div
                        className="
            text-center
            py-16
            text-gray-500
            "
                    >
                        No Joined Offers
                    </div>
                ) : (
                    <div
                        className="
            grid
            md:grid-cols-2
            xl:grid-cols-3
            gap-6
            "
                    >
                        {offers.map((offer) => (
                            <div
                                key={offer.id}
                                className="
                bg-black
                rounded-2xl
                overflow-hidden
                border
                border-yellow-500/10
                hover:border-yellow-500/40
                transition-all
                duration-300
                "
                            >
                                <img
                                    src={
                                        offer.banner
                                            ? `${process.env.REACT_APP_API_URL}/uploads/${offer.banner}`
                                            : "https://via.placeholder.com/500x300"
                                    }
                                    alt={offer.title}
                                    className="
                  w-full
                  h-48
                  object-cover
                  "
                                />

                                <div className="p-5">

                                    <h3
                                        className="
                    text-lg
                    font-bold
                    "
                                    >
                                        {offer.title}
                                    </h3>

                                    <p
                                        className="
                    text-yellow-400
                    text-sm
                    mt-1
                    "
                                    >
                                        {offer.category}
                                    </p>

                                    <p
                                        className="
                    text-gray-400
                    text-sm
                    mt-3
                    line-clamp-3
                    "
                                    >
                                        {offer.description}
                                    </p>

                                    <div
                                        className="
                    mt-4
                    text-xs
                    text-gray-500
                    "
                                    >
                                        Joined:
                                        {" "}
                                        {offer.joined_at
                                            ? new Date(
                                                offer.joined_at
                                            ).toLocaleString()
                                            : "N/A"}
                                    </div>

                                    {(offers.length > 0 || offers[0].is_joined_status === 1) && (
                                        <Link
                                            to={`/admin/users/${user.id}/offers/${offer.id}`}
                                            className="mt-5 inline-flex items-center px-4 py-2 rounded-lg bg-yellow-500 text-black font-semibold"
                                        >
                                            View Details →
                                        </Link>
                                    )}



                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {previewImage && (

                <div
                    onClick={() =>
                        setPreviewImage(null)
                    }
                    className="
    fixed
    inset-0
    bg-black/90
    flex
    items-center
    justify-center
    z-[9999]
    p-4
    "
                >

                    <div className="relative">

                        <button
                            onClick={() =>
                                setPreviewImage(null)
                            }
                            className="
        absolute
        -top-4
        -right-4
        w-10
        h-10
        rounded-full
        bg-red-500
        text-white
        font-bold
        "
                        >
                            ✕
                        </button>

                        <img
                            src={previewImage}
                            alt=""
                            className="
        max-w-[90vw]
        max-h-[90vh]
        rounded-2xl
        object-contain
        "
                        />

                    </div>

                </div>

            )}

        </div>
    );
}

export default UserDetails;